import index from './plan-compare';
export default index;
